export default "__VITE_ASSET__Cy58ddxB__"